import * as Ajax from '@runway/util-ajax';

export const name = 'poll-endpoint';

const MAX_RETRIES = 20;
const CHANGE_MESSAGE_TIMEOUT = 5000;
const RETRY_TIMEOUT = 500;

export default class PollEndpoint {
    get name() {
        return name;
    }

    constructor(node) {
        const { pollingEndpoint, pollingActiveMessage } = this.data;

        this.node = node;
        this.retries = 0;
        this.url = pollingEndpoint;
        this.currentMessageId = parseInt(pollingActiveMessage, 10);
        this.pendingMessages = Array.from(node.getElementsByClassName('rw-notification-message__content'));
        this.init();
    }

    manageMessage() {
        if (this.currentMessageId >= this.pendingMessages.length) {
            return;
        }

        window.setTimeout(() => this.manageMessage(), CHANGE_MESSAGE_TIMEOUT);

        this.showSpecificMessage(this.currentMessageId);
    }

    showSpecificMessage(messageNumber) {
        this.hideAllMessages();
        this.pendingMessages[messageNumber].hidden = false;
        this.currentMessageId += 1;
    }

    hideAllMessages() {
        this.pendingMessages.forEach(messageDiv => {
            messageDiv.hidden = true;
        });
    }

    init() {
        this.manageMessage();
        this.pollEndPoint();
    }

    pollEndPoint() {
        Ajax.send(this.url, {
            method: 'GET',
            headers: {
                accept: 'application/json' 
            },
            includeDefaultHeaders: false
        }).then(response => {
            this.handleResponse(response);
        });
    }

    handleResponse({ responseText }) {
        const isFinal = JSON.parse(responseText);

        if (isFinal) {
            window.location.reload();
        }

        if (this.retries < MAX_RETRIES) {
            window.setTimeout(() => this.pollEndPoint(), RETRY_TIMEOUT);
            this.retries += 1;
        }
    }
}
